import './bindCode.scss'
import { useLocal } from '@/i18n/LocalContext'
import CommonModal from '../CommonModal/CommonModal'
import { useStore } from '@/store'
import Prop from '../Prop/Prop'
import CodeInput from '../CodeInput/CodeInput'
import { $alert, closeLoading, download, loading, rpx } from '@/utils'
import { useCallback, useState } from 'react'
import { bindCode } from '@/request'
import { clickReport } from '@/report'

export default function BindCode() {
  const inSDK = window.inSDK
  const { $t } = useLocal()
  const { state, dispatch } = useStore()
  const zoneId = state.login.userInfo.zoneId
  const playerId = state.login.userInfo.playerId
  const bindRewardViews = state.bindRewardViews
  const code = state.code
  const [open, setOpen] = useState(
    window.queryObj.modal === 'codeGet' ? true : false
  )

  const go = () => {
    clickReport('download2')
    download(zoneId)
  }

  const handle = useCallback(async () => {
    if (code.length === 0 || code.length > 9) {
      return $alert($t('ERR_INVITATION_CODE_NOT_EXIST'))
    }

    loading()
    const res = await bindCode(playerId, code)
    closeLoading()

    if (!res.nickName) return

    dispatch({
      type: 'bindCode',
      data: {
        isCodeBinded: true,
      },
    })
    setOpen(true)

    dispatch({
      type: 'updateModal',
      data: {
        recallOpen: false,
      },
    })
  }, [code, playerId])

  const onClose = () => {
    setOpen(false)
  }

  return (
    <>
      <CommonModal
        open={state.modalData.recallOpen}
        title={$t('欢迎回归')}
        type="recall"
        length="long"
      >
        {[
          <div key="1" className="bind-code">
            <div className="banner">
              <div className="banner-slogan">
                <span className="banner-slogan__shadow">
                  {$t('欢迎归来，领主大人！')}
                </span>
                <span className="banner-slogan__text">
                  {$t('欢迎归来，领主大人！')}
                </span>
              </div>
              <p className="banner__text">
                {$t(
                  '填写其他领主邀请码完成绑定，您即可获得价值$19.99的回归好礼！'
                )}
              </p>
            </div>
            <ul className="recall-prop-list">
              {bindRewardViews.map((reward) => (
                <li key={reward.name} className="recall-prop">
                  <Prop
                    level={3}
                    name={reward.name}
                    imgSrc={reward.icon}
                    count={reward.count}
                    get={false}
                    desc={reward.desc}
                  />
                </li>
              ))}
            </ul>
            <div className="code-box">
              <span className="code-box__name">{$t('邀请码')}</span>
              <CodeInput />
            </div>
          </div>,
          [
            !inSDK ? (
              <a
                key="21"
                className="common-modal-reject common-modal-reject--blue"
                onClick={go}
              >
                <span>{$t('前往')}</span>
              </a>
            ) : null,
            <a key="22" className="common-modal-btn" onClick={handle}>
              <span>{$t('确定')}</span>
            </a>,
          ],
        ]}
      </CommonModal>
      <CommonModal open={open} title={$t('恭喜获得')} onClose={onClose}>
        {[
          <div key="1" className="receive">
            <ul className="receive-prop-list">
              <p
                className="common-modal-text"
                style={{ fontWeight: 'bold', fontSize: rpx(30), color: '#333' }}
              >
                {$t('您已成功绑定{code}领主的回归邀请码').replace(
                  '{code}',
                  code
                )}
              </p>
            </ul>
            <p className="common-modal-text">
              {$t(
                '奖励将通过游戏内邮件发送给您，邮件有效期30天，请您尽快领取！'
              )}
            </p>
          </div>,
          [
            <a key="21" className="common-modal-btn" onClick={onClose}>
              <span>{$t('确定')}</span>
            </a>,
          ],
        ]}
      </CommonModal>
    </>
  )
}
